import React from 'react';
import { Link } from 'react-router';
import moment from 'moment';

export default function Selected(props) {
  const { data, caseData, onDelete } = props;
  const _onDelete = function (selectedData) {
    onDelete(selectedData);
  };

  return (
    <div className="sets-list-blocks p-0">
      <div className="sets-block">
        <ul className="list-unstyled">
          {
              data.length > 0
                ? data.map((selectData, key) => (
                  selectData.productId !== ''
                  && (
                  <li className="pt-1 pb-1" key={key}>
                    <div className="contents-wrap">
                      <div className="row gx-2">
                        <div className="col-auto">
                          <div className="left-icon">
                            {moment(caseData.CaseDate) >= moment() ? (
                              <Link onClick={() => _onDelete(selectData, key)}>
                                <i className="fas fa-trash theme-color cursor-pointer" />
                              </Link>
                            ) : ''}
                          </div>
                        </div>
                        <div className="col">
                          <div className="row gx-2">
                            <div className="col">
                              <p>{selectData.productId.startsWith('null') ? selectData.productId.split('null') : selectData.productId}</p>
                            </div>
                            <div className="col text-center" />
                            <div className="col text-end" />
                          </div>
                          <p>{selectData.ProductDescription}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  )
                )) : <p className="text-center mt-5">There are no selected products for this case.</p>
          }
        </ul>
      </div>
    </div>
  );
}
